import type { RouteObject } from 'react-router-dom';
import { ALL_ROUTES } from '../consts/routes';
import { CreatePassword, Signup } from '../pages';
import { RequireQueryParam } from '../utils/RequireQueryParam';
import { OnboardLayout } from '@/Layouts';

/**
 * Routes accessible both authenticated and unauthenticated
 * - Join organization, create password
 */
export const useSharedRoutes = (): RouteObject[] => {
  return [
    {
      path: '/',
      element: <OnboardLayout />,
      children: [
        {
          path: ALL_ROUTES.JOIN_ORGANIZATION,
          element: <RequireQueryParam param='token' Component={Signup} />,
        },
        {
          path: ALL_ROUTES.NEW_PASSWORD,
          element: <RequireQueryParam param='token' Component={CreatePassword} />,
        },
      ],
    },
  ];
};
